module.exports = __webpack_public_path__ + "static/img/14000794.01acc9f4.png";